import { render, staticRenderFns } from "./virtual-upload.vue?vue&type=template&id=2ff6c2e0&scoped=true&"
import script from "./virtual-upload.vue?vue&type=script&lang=js&"
export * from "./virtual-upload.vue?vue&type=script&lang=js&"
import style0 from "./virtual-upload.vue?vue&type=style&index=0&lang=less&"
import style1 from "./virtual-upload.vue?vue&type=style&index=1&id=2ff6c2e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff6c2e0",
  null
  
)

export default component.exports